import { useMutation } from "@tanstack/react-query";
import ActionService from "../services/actions";
import { useState } from "react";

const useActionDropdown = () => {
  const [actionData, setActionData] = useState({})

  const mutateLoad = useMutation({
    mutationFn: ({ idAction, idDetail, model, context = {} }) => {
      return ActionService.loadAction({ idAction, idDetail, model, context })
    }
  })

  const closeModal = () => {
    setActionData((prev) => ({ ...prev, openModal: false }))
  }

  const handleClickDropdownAction = async (action, idDetail, model, context) => {
    if (action?.type === 'ir.actions.act_window') {
      const response = await mutateLoad.mutateAsync({ idAction: action?.id, idDetail, model, context })
      if (response && response?.result) {
        setActionData({ ...response?.result, openModal: true })
      }
    }
  }

  return {
    actionData,
    handleClickDropdownAction,
    closeModal
  };
};

export default useActionDropdown;